import React, { useEffect } from 'react';
import "../../styles/Services.css";
import GetInTouch from '../../components/GetInTouch';
const seoIcon = "/assets/icons/seo_icon.png";
const socialIcon = "/assets/icons/social_media icon.png";
const contentmarketingIcon = "/assets/icons/content marketing icon.png";
const emailmarketingIcon = "/assets/icons/email_marketing icon.png";



const DigitalMarketing = () => {
  useEffect(() => {
    document.title = 'Digital marketing | Inypeople';
  }, []);


  return (
    <>
    <section className="web-dev-section digital-marketing-page">
  <div className="web-dev-container">
    <h1 className="web-dev-title">Digital Marketing</h1>
      <p className="digital-marketing-description">
    
      At Inypeople, digital marketing services leverage advanced targeting, data-driven insights, and creative strategies to amplify your brand’s reach and engagement. We craft campaigns that connect with the right audience at the right time, ensuring measurable impact across digital channels.

      <br />
      <br />
      By transforming your digital and social presence into a dynamic growth engine, we help you build meaningful relationships and drive consistent sales. Our focus is on performance, scalability, and long-term brand value—turning engagement into real business outcomes.
    </p>
  </div>

  <div className="circle circle-left"></div>
  <div className="circle circle-right"></div>
  <div className="circle circle-right-top"></div>
  <div className="circle circle-left-bottom"></div>
</section>


      <section className="services-section">
        <div className="services-container">
          <h2 className="services-main-title">Smart digital marketing to boost business engagement</h2>

          <div className="services-grid">
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={seoIcon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Search Engine Optimization (SEO)</h3>
                </div>

                <p className="service-description">
                  Improve your website’s visibility and organic rankings across search engines. Our SEO strategies drive qualified traffic and long-term growth. Focused on performance, relevance, and measurable results.
                </p>
              </div>
            </div>

            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={socialIcon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Social Media Marketing & Management</h3>
                </div>
                <p className="service-description">
                  Create visually engaging and consistent interfaces across web and mobile platforms. Designs that reflect your brand while ensuring clarity, accessibility, and usability.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={contentmarketingIcon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Content Marketing & Blogging</h3>
                </div>
                <p className="service-description">
                  Deliver valuable, relevant content that attracts and educates your audience. Our content strategies build authority, trust, and consistent inbound leads. Designed to support your marketing goals.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={emailmarketingIcon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Email Marketing & Automation</h3>
                </div>
                <p className="service-description">
                  Personalized email campaigns that nurture leads and retain customers. Automation ensures timely, relevant communication at scale. Drive conversions with data-driven messaging.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Add GetInTouch at the bottom of this service page */}
      <GetInTouch />
    </>
  );
};

export default DigitalMarketing;
